/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Pairing_AmbiguousInputs */

const cs_ebr_pairing_ambiguous = /** @type {(inputs: Ebr_Pairing_AmbiguousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nejednoznačné`)
};

const en_ebr_pairing_ambiguous = /** @type {(inputs: Ebr_Pairing_AmbiguousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ambiguous`)
};

/**
* | output |
* | --- |
* | "ambiguous" |
*
* @param {Ebr_Pairing_AmbiguousInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_pairing_ambiguous = /** @type {((inputs?: Ebr_Pairing_AmbiguousInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Pairing_AmbiguousInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_pairing_ambiguous(inputs)
	return cs_ebr_pairing_ambiguous(inputs)
});